import { findIndex } from 'lodash'

export default {
  editSurvey(state, data) {
    const index = findIndex(state.surveys, { surveyDetailId: data.surveyDetailId })
    if (index > -1) {
      state.surveys[index].values = data.values
    } else {
      state.surveys.push(data)
    }
  }
}
